import React, { Component } from "react";
import { DatePicker, Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import { speech_demographics_form_type } from "../../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";

export default class DateOfBirthForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date_of_birth: null,
      gender:"",
      loading: false,
      email:"",
      neurostamp_id:"",
      modality_id:"",
      question_list:[],
      field_data:[],
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.date_of_birth_and_sex;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          let arr=[]
          const filteredData = response.data.filter(item => item.field=='DEMOG1' || item.field=='DEMOG3');
          this.setState({
            question_list: filteredData,
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
            field_data: response.field_data.date_of_birth_and_sex
          })
          for(let item of response.data){
            if(item.field=='DEMOG1'||item.field=='DEMOG3'){
              arr.push(item)
            }
            if(item.field=='DEMOG1'){
              this.setState({
                date_of_birth:item.value?dayjs(item.value):null
              })
            }
            if(item.field=='DEMOG3'){
              this.setState({
                gender:item.value?item.value:""
              })
            }
          }
          this.setState({            
            loading:false
          })
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  // step 1
  save_details = () => {
    if (!this.state.date_of_birth) {
      message.warning("Please select a valid date!");
      return;
    }
    let last18YearsStartDate = moment().subtract(18, "years");
    last18YearsStartDate = moment(last18YearsStartDate).format("YYYY-MM-DD");
    let dob2 = dayjs(this.state.date_of_birth).format("YYYY-MM-DD");
    if (dob2 > last18YearsStartDate) {
      message.warning(
        "Min Age must be 18 Years. Please select valid Date Of birth"
      );
      return;
    }
    let dob = dayjs(this.state.date_of_birth).format("MM/DD/YYYY");

    if (!this.state.gender) {
      message.warning("Choose one option!");
      return;
    }
    let questions=[]
    let list=this.state.field_data
    for(let item of list){
      if(item.field=='DEMOG1'){
        let obj={
          value:dob,
          view_name:item.view_name,
          form:"Date of Birth and Sex",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DEMOG3'){
        let obj={
          value:this.state.gender,
          view_name:item.view_name,
          form:"Date of Birth and Sex",
          field: item.field
        }
        questions.push(obj)
      }
    }
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.date_of_birth_and_sex,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
    .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(3);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Date of Birth and Sex</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                What is your Date of Birth?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/DD/YYYY"}
                disabledDate={disabledDate}
                value={this.state.date_of_birth}
                placement={'bottom'}
                placeholder="What is your Date of Birth?"
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="form-group">
              <label className="input-heading">
              What was your assigned sex at birth?{" "}
              <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) => {
                  this.setState({ gender: e.target.value })
                }}
                value={this.state.gender}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"1"}>Male</Radio>
                  <Radio value={"2"}>Female</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    background: "#b3b3b3",
                    cursor: "auto",
                  }}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
